import {Stack} from '@primer/react'
import type {AppListing} from '@github-ui/marketplace-common'
import type {FeaturedCustomer, PlanInfo} from '../../types'
import {About} from './About'
import {VerifiedOwner} from '../sidebar-shared/VerifiedOwner'
import {PlanInfo as SidebarPlanInfo} from './sidebar/PlanInfo'
import {Languages} from './sidebar/Languages'
import {Customers} from './sidebar/Customers'
import {WorksWith} from './sidebar/WorksWith'
import {Resources} from './sidebar/Resources'
import {Tags} from '../sidebar-shared/Tags'

export type SidebarProps = {
  app: AppListing
  supportedLanguages: string[]
  customers: FeaturedCustomer[]
  planInfo: PlanInfo
}

export function Sidebar({app, supportedLanguages, customers, planInfo}: SidebarProps) {
  return (
    <Stack gap={'spacious'}>
      <About app={app} sidebar />
      <VerifiedOwner isVerifiedOwner={app.isVerifiedOwner} pageType="apps" />
      <Tags tags={app.categories} type="apps" />
      <SidebarPlanInfo planInfo={planInfo} isCopilotApp={app.copilotApp} />
      <WorksWith isCopilotApp={app.copilotApp} />
      <Languages supportedLanguages={supportedLanguages} />
      <Customers customers={customers} />
      <Resources app={app} />
    </Stack>
  )
}

try{ Sidebar.displayName ||= 'Sidebar' } catch {}